import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import { EmptyState } from "../shared/EmptyState";

const MARKET_DOT = { "O/U": "bg-green-500" };

export const BestBetsPanel = ({ bets = [], loading = false }) => {
  return (
    <div data-testid="panel-best-bets" className="rounded-lg border border-white/10 bg-eb-surface p-4">
      <h3 className="mb-3 font-heading text-lg uppercase tracking-tight text-white">Largest Leans</h3>
      {loading ? (
        <div data-testid="best-bets-loading" className="py-6 text-center font-mono text-xs text-zinc-500">
          Scanning today&apos;s slate&hellip;
        </div>
      ) : bets.length > 0 ? (
        <div data-testid="best-bets-list" className="flex flex-col gap-2">
          {bets.map((bet) => (
            <Link
              key={`${bet.gameId}-${bet.market}`}
              to={`/games/${bet.gameId}`}
              data-testid={`best-bet-${bet.gameId}-${bet.market === "ML" ? "ml" : "ou"}`}
              className="flex items-center justify-between gap-3 rounded-md border border-white/5 bg-eb-bg px-3 py-2 transition-colors hover:border-white/20"
            >
              <div className="flex items-center gap-2">
                <span className={`h-2 w-2 shrink-0 rounded-full ${MARKET_DOT[bet.market]}`} />
                <div className="flex flex-col">
                  <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">
                    {bet.market} &middot; {bet.awayName} @ {bet.homeName}
                  </span>
                  <span className="font-heading text-sm text-white">{bet.pick}</span>
                </div>
              </div>
              <span data-testid={`best-bet-${bet.gameId}-${bet.market === "ML" ? "ml" : "ou"}-confidence`} className="shrink-0 font-mono text-sm text-white">
                {(bet.confidence * 100).toFixed(0)}%
              </span>
            </Link>
          ))}
        </div>
      ) : (
        <EmptyState
          icon={Sparkle}
          title="No Strong Leans Yet"
          description="Largest Leans appear here once today's model confidence crosses 58% on either side."
          testId="empty-state-best-bets"
        />
      )}
    </div>
  );
};
